import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (!content) return null;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  let created = false;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
    created = true;
  }
  const prev = el.getAttribute("content");
  el.setAttribute("content", content || "");
  return { el, created, prev };
}

// Lightweight SEO manager for a SPA: sets document.title + meta description
// and Open Graph tags, then restores the previous title on unmount.
export default function useSeo({ title, description, image, url }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const refs = [
      upsertMeta("name", "description", description),
      upsertMeta("property", "og:title", title),
      upsertMeta("property", "og:description", description),
      upsertMeta("property", "og:image", image),
      upsertMeta("property", "og:url", url),
      upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary"),
      upsertMeta("name", "twitter:title", title),
      upsertMeta("name", "twitter:description", description),
      upsertMeta("name", "twitter:image", image),
    ].filter(Boolean);

    return () => {
      document.title = prevTitle;
      refs.forEach((r) => {
        if (!r) return;
        if (r.created) r.el.remove();
        else if (r.prev !== null) r.el.setAttribute("content", r.prev);
      });
    };
  }, [title, description, image, url]);
}
